import React from 'react';
import ReactTable from 'react-table'
import 'react-table/react-table.css';
import '../../../scss/_react-table-list.scss';


class CustomList extends React.Component {

    constructor(props) {
        super(props);

        this.pageSizeOptions = [5, 10, 20, 25, 50, 100];
        this.refreshPageSizeOptions = this.refreshPageSizeOptions.bind(this);

        this.state = {
            pageSize: null
        };
    }

    componentDidMount() {
        this.refreshPageSizeOptions();
    }

    componentWillReceiveProps(newProps) {
        if(newProps.data.length !== this.itemsCount) {
            this.refreshPageSizeOptions(newProps);
        }
    }

    refreshPageSizeOptions(props) {
        props = props || this.props;
        this.itemsCount = props.data
            ? props.data.length
            : 0;

        if(!props.pageSizeOptions && this.itemsCount) {
            this.pageSizeOptions = [];

            for(let i = this.itemsCount; i > 0; i = i - 5) {
                this.pageSizeOptions.unshift(i);
            }
        }

        this.state.pageSize = this.pageSizeOptions[1] || this.pageSizeOptions[0];
    }

    render() {
        let {
            columns,
            data,
            filterable = true,
            defaultPageSize = 20,
        } = this.props;

        if(!data.length) {
            return null;
        }

        return (
            <ReactTable
                data={data}
                columns={columns}
                filterable={filterable}
                pageSizeOptions={this.pageSizeOptions}
                defaultPageSize={defaultPageSize}
                pageSize={this.state.pageSize}
                onPageSizeChange={pageSize => this.setState({pageSize})}
                previousText={'Forrige'}
                nextText={'Næste'}
                pageText={'Side'}
                ofText={'af'}
                rowsText={'rækker'}
                loadingText={'Indlæser...'}
                noDataText={'Ingen data'}
                {...this.props}
            />
        );
    }
}

export default CustomList;


// WEBPACK FOOTER //
// ./web/src/components/common/CustomList.jsx